import React, { useState } from "react";
import { Column, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabeceraReporte } from "../../Componentes/Basicos/LVGridCabeceraReporte";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";

export const VEN_Reservas_ResumenDeEventos = () => {
  const [data, setData] = useState([])

  const [FechaDesde, setFechaDesde] = useState(new Date());
  const [FechaHasta, setFechaHasta] = useState(new Date());

  const { VEN_Reservas_Cabecera: { function_VEN_Reservas_Cabecera_ResumenEventos } } = require('neftis7_apicaller');
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');

  const handleDataLoaded = async (data) => {    
    try {
      setData(data);
    } catch (error) {
      alert(error);
    }
  };
  
  return (
    <PaginaListado
      Titulo="RESUMEN DE EVENTOS"
      funcion={function_VEN_Reservas_Cabecera_ResumenEventos}
      onDataLoaded={handleDataLoaded}
      setDesde={setFechaDesde}
      setHasta={setFechaHasta}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          
          <LVButtonReporte Url="/VEN_Reservas_ResumenDeEventos_Calendario" Texto="VISTA CALENDARIO" />
        </div>
        {data.length > 0 ? (
          <LVGridCabeceraReporte
            dataSource={data}
            id="gridContainer"
            keyExpr="IdReserva"
            urlEdicion="/ReservasAlta"
          >
            <Summary>
              <TotalItem
                column="IdReserva"
                summaryType="count"
                customizeText={summaryItem => `Eventos: ${summaryItem.value}`} />
              <TotalItem
                column="Cantidad"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />
              <TotalItem
                column="Participantes"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />


              <GroupItem
                column="IdReserva"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Código" dataField="IdReserva" width="110" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />

            <Column caption="Evento" alignment="Center" >
              <Column caption="Código" dataField="CodigoArticulo" width="100" alignment="Right" dataType="number" />
              <Column caption="Descripción" dataField="Articulo" width="200" minWidth={100} alignment="Left" dataType="string" />
              <Column caption="Formato" dataField="Formato" width="200" minWidth={100} alignment="Left" dataType="string" />
            </Column>

            <Column caption="Cliente" alignment="Center" >
              <Column caption="Código" dataField="IdClienteGenerador" width="100" alignment="Right" dataType="number" />
              <Column caption="Nombre Apellido" dataField="ClienteGenerador" width="200" minWidth={100} alignment="Left" dataType="string" />
            </Column>

            <Column caption="Agasajado" alignment="Center" >
              <Column caption="Código" dataField="IdCliente" width="120" alignment="Right" dataType="string" />
              <Column caption="Nombre Apellido" dataField="Cliente" width="100%" minWidth={100} alignment="Left" dataType="string" />
            </Column>

            <Column caption="Reserva" alignment="Center" >
              <Column caption="Cantidad" dataField="Cantidad" width="100" alignment="Right" dataType="number" />
              <Column caption="Participantes" dataField="Participantes" width="150" alignment="Right" dataType="number" />
            </Column>
          </LVGridCabeceraReporte>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
